import { defineStore } from 'pinia';
import { NotificationStatus } from '~/api/notifications/_types';

export const useNotificationsStore = defineStore('notifications', () => {
    const status = ref<NotificationStatus | null>(null);
    const needNotificationsRefresh = ref(false);

    const setNotificationsRefresh = (value: boolean) => {
        needNotificationsRefresh.value = value;
    };

    return {
        status,
        needNotificationsRefresh,
        setNotificationsRefresh,
    };
});
